module.exports = __webpack_public_path__ + "static/media/PremiumSleep.d9f54470.png";